(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lovelace-featured-cards"] && !Shopify.designMode) return;
  try {
    
  const backgrounds = [...document.querySelectorAll('.featuredCards__background__image')];
  const cards = [...document.querySelectorAll('.featuredCards__card')];
  let cardsInView = [];

  const handleScroll = (e) => {
    if (cardsInView.length > 0) {
      const target = window.innerHeight / 2;
      const closest = cardsInView.reduce((a, b) => {
        const cardCenterPositionA = a.getBoundingClientRect().top + a.getBoundingClientRect().height / 2;
        const cardCenterPositionB = b.getBoundingClientRect().top + b.getBoundingClientRect().height / 2;
        return Math.abs(cardCenterPositionB - target) < Math.abs(cardCenterPositionA - target) ? b : a;
      });
      const index = parseInt(closest.dataset.identifier, 10);
      backgrounds.forEach((b, i) => {
        if (i === index) {
          b.classList.add('is-active');
        } else {
          b.classList.remove('is-active');
        }
      });
    }
  };
  window.addEventListener('scroll', handleScroll);
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const intersecting = entry.isIntersecting;
      if (intersecting) {
        cardsInView.push(entry.target);
      } else {
        cardsInView = cardsInView.filter((card) => card.dataset.identifier !== entry.target.dataset.identifier);
      }
    });
  });
  cards.map((el) => {
    observer.observe(el);
  });

  } catch(e) { console.error(e); }
})();
})();
